module.exports = __webpack_public_path__ + "img/操作手册_01.cf7795d8.svg";